import ProductDetail from "../../Inventory/Tabs/ProductList/ProductDetail";
import ComponentForecast from "./ChatComponent/Forecast/ComponentForecast";
import FinishedGoodsForecast from "./ChatComponent/Forecast/FinishedGoodsForecast";
import AddProduct from "./ChatComponent/Inventory/AddProduct";
import AddStockToWarehouse from "./ChatComponent/Inventory/AddStockToWarehouse";
import AdjustStock from "./ChatComponent/Inventory/AdjustStock";
import ArchieveProduct from "./ChatComponent/Inventory/ArchiveProduct";
import CreatePO from "./ChatComponent/Inventory/CreatePO";
import PinProduct from "./ChatComponent/Inventory/PinProduct";
import TransferStock from "./ChatComponent/Inventory/TransferStock";
import UpdateProduct from "./ChatComponent/Inventory/UpdateProduct";
import ViewComponent from "./ChatComponent/Inventory/ViewComponent";
import ViewProductList from "./ChatComponent/Inventory/ViewProductList";
import SalesCanvas from "./ChatComponent/SalesOrder/SalesCanvas";
import SalesOrderTable from "./ChatComponent/SalesOrder/SalesOrderTable";
import SalesTargetTable from "./ChatComponent/SalesTargetTable";
import ViewProduct from "./ChatComponent/Inventory/ViewProduct";

const SalesTargetRenderer = ({ resultMessage, expandedId, threadId, messageId }) => {
    if (resultMessage?.salesTarget?.length > 0 && !expandedId) {
        return (
            <div className="mb-2">
                <SalesTargetTable
                    salesTarget={resultMessage?.salesTarget}
                    summary={resultMessage?.summary}
                    threadId={threadId}
                    messageId={messageId}
                />
            </div>
        );
    }
    return null;
};

const SalesOrdersRenderer = ({ resultMessage, toolName, expandedId }) => {
    if (resultMessage?.orders?.length > 0 && !expandedId) {
        return (
            <div className="mb-2">
                <SalesOrderTable resultMessage={resultMessage} toolName={toolName} />
            </div>
        );
    }
    return null;
};

const OrderDetailsRenderer = ({
    resultMessage,
    expandedId,
    setExpandedId,
    messageId,
    toolName,
}) => {
    if (resultMessage?.order?.salesOrder) {
        return (
            <div className="mb-2">
                <SalesCanvas
                    isExpanded={expandedId}
                    setIsExpanded={setExpandedId}
                    messageId={messageId}
                    summary={resultMessage?.summary}
                    salesOrderDetail={resultMessage?.order?.salesOrder}
                    toolName={toolName}
                />
            </div>
        );
    }
    return null;
};

const ComponentsForecastRenderer = ({ resultMessage, toolName }) => {
    if (resultMessage?.inventories?.length > 0) {
        return (
            <div className="mb-2">
                <ComponentForecast resultMessage={resultMessage} toolName={toolName} />
            </div>
        );
    }
    return null;
};

const FinishedGoodsRenderer = ({ resultMessage, toolName }) => (
    <div className="mb-2">
        <FinishedGoodsForecast resultMessage={resultMessage} toolName={toolName} />
    </div>
);

const AddProductRenderer = ({ resultMessage, toolName }) =>
    resultMessage?.success && (
        <div className="mb-2">
            <AddProduct resultMessage={resultMessage} toolName={toolName} />
        </div>
    );

const PinProductRenderer = ({ resultMessage, toolName }) =>
    resultMessage?.success && (
        <div className="mb-2">
            <PinProduct resultMessage={resultMessage} toolName={toolName} />
        </div>
    );

const ArchiveProductRenderer = ({ resultMessage, toolName }) =>
    resultMessage?.success && (
        <div className="mb-2">
            <ArchieveProduct resultMessage={resultMessage} toolName={toolName} />
        </div>
    );

const UpdateProductRenderer = ({ resultMessage, toolName }) =>
    resultMessage?.success && (
        <div className="mb-2">
            <UpdateProduct resultMessage={resultMessage} toolName={toolName} />
        </div>
    );

const ViewProductListRenderer = ({ resultMessage, toolName }) =>
    resultMessage?.success && (
        <div className="mb-2">
            <ViewProductList resultMessage={resultMessage} toolName={toolName} />
        </div>
    );

const ViewComponentRenderer = ({ resultMessage, toolName }) =>
    resultMessage?.success && (
        <div className="mb-2">
            <ViewComponent resultMessage={resultMessage} toolName={toolName} />
        </div>
    );

const AddStockRenderer = ({ resultMessage, toolName, expandedId }) =>
    resultMessage?.success && (
        <div className="mb-2">
            <AddStockToWarehouse resultMessage={resultMessage} toolName={toolName} />
        </div>
    );

const TransferStockRenderer = ({ resultMessage, toolName }) =>
    resultMessage?.success && (
        <div className="mb-2">
            <TransferStock resultMessage={resultMessage} toolName={toolName} />
        </div>
    );

const AdjustStockRenderer = ({ resultMessage, toolName }) =>
    resultMessage?.success && (
        <div className="mb-2">
            <AdjustStock resultMessage={resultMessage} toolName={toolName} />
        </div>
    );

const CreatePORenderer = ({ resultMessage, toolName }) =>
    resultMessage?.success && (
        <div className="mb-2">
            <CreatePO resultMessage={resultMessage} toolName={toolName} />
        </div>
    );

const ViewProductRenderer = ({
    resultMessage,
    toolName,
    expandedId,
    setExpandedId,
    messageId,
}) =>
    resultMessage?.success && (
        <div className="mb-2">
            <ViewProduct
                inventoryId={resultMessage?.product?.id}
                toolName={toolName}
                resultMessage={resultMessage}
                isExpanded={expandedId}
                setIsExpanded={setExpandedId}
                messageId={messageId}
            />
        </div>
    );

export const toolRenderers: Record<string, React.FC<any>> = {
    GenerateSalesTargetForecast: SalesTargetRenderer,
    listSalesOrders: SalesOrdersRenderer,
    updateOrderStatus: SalesOrdersRenderer,
    getOrderDetails: OrderDetailsRenderer,
    // Forecast
    ViewComponentsForecast: ComponentsForecastRenderer,
    ViewFinishedGoodsForecastGraph: FinishedGoodsRenderer,
    // Inventory
    AddSingleProduct: AddProductRenderer,
    AddBundledProduct: AddProductRenderer,
    UpdateProduct: UpdateProductRenderer,
    PinProduct: PinProductRenderer,
    ArchiveProduct: ArchiveProductRenderer,
    SearchProducts: ViewProductListRenderer,
    ViewComponents: ViewComponentRenderer,
    AddStock: AddStockRenderer,
    AddStockToWarehouse: AddStockRenderer,
    TransferStock: TransferStockRenderer,
    AdjustStock: AdjustStockRenderer,
    CheckStockoutAndCreatePO: CreatePORenderer,
    ViewProduct: ViewProductRenderer,
};
